import { Box, Text } from '@chakra-ui/react'

export function HeaderSection({ title }) {
  return (
    <Box bg="#378BBF" color="white" py={4} textAlign="center" w="100%">
      <Text fontSize="md" fontWeight="bold">
        {title}
      </Text>
    </Box>
  )
}
